import { useMap } from "react-leaflet";
import { useEffect, useState } from "react";
import L from 'leaflet';



// Fonction pour recentrer la map sur la position choisie
export function Recenter({ coordonnéesPointCentral, showMenuLateral, isPhone }) {
    const map = useMap();
    const [firstRender, setFirstRender] = useState(true); // Pour détecter le premier rendu

    useEffect(() => {
        if (!map || !coordonnéesPointCentral) return;

        const { lat, lng } = coordonnéesPointCentral;

        const recenterMap = () => {
            if (showMenuLateral) {
                const offsetX = map.getSize().x * 0.165; // Décalage de ~16.5% de la largeur
                const point = map.project([lat, lng]); // Convertit lat/lng en coordonnées pixel
                point.x += offsetX; // Applique le décalage horizontal
                const newCenter = map.unproject(point); // Reconvertit en lat/lng

                map.setView([newCenter.lat, newCenter.lng], map.getZoom()); // Déplacement instantané
            } else {
                map.setView([lat, lng], map.getZoom()); // Déplacement instantané
            }
        };

        if (firstRender && showMenuLateral) {
            setTimeout(() => recenterMap(), 20); // Petit délai pour éviter les bugs de chargement
            setFirstRender(false);
        } else {
            recenterMap();
        }

    }, [coordonnéesPointCentral, showMenuLateral, map, firstRender]);

    return null;
}





// Fonction pour recentrer la map sur la position choisie pour Modal
export function RecenterModal({ coordinates }) {
    const map = useMap();
    useEffect(() => {
        map.setView([coordinates.lat, coordinates.lng], map.getZoom());
    }, [coordinates, map]);
    return null;
}




// Fonction pour adapter le "zoom" à la taille du cercle
export function FitBounds({ center, rayonDeRecherche, active }) {
    const map = useMap();
    useEffect(() => {
        if (active) {
            const circleBounds = L.latLng(center).toBounds(rayonDeRecherche * 1.5);
            map.fitBounds(circleBounds);
        }
    }, [center, rayonDeRecherche, active, map]);

    return null;
}


